module.exports = __webpack_public_path__ + "img/guide-bg.05e6dbe4.png";